import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";

import {Grey6} from "../../theme/styles";

// Does this change require people to retrain?
//
// ASKED OF THE AUTHOR, AT SUBMIT. Whether a change is administrative is a judgement about what was
// changed, and the person holding the draft is the one who knows. Captured here it also becomes
// part of what the approvers are shown and sign for, rather than a decision made invisibly after
// the signatures are in.
//
// IT USED TO BE ASKED AT RELEASE, which under an approval matrix is not an act anybody performs --
// it is what happens on the final signature. So the question landed on an approver with no field to
// answer it in: Adaeze Nwosu signed SOP-00001, the signature recorded, and the release then refused,
// leaving the sign panel open on an error she could do nothing about.
//
// NO DEFAULT BUTTON AND NO CANCEL-AS-ANSWER. Defaulting either way would be a decision nobody made:
// yes, and a typo fix retrains the company; no, and a rewritten procedure quietly does not. Cancel
// abandons the submission, which is the only honest third option.

export default function RetrainingDialog({open, busy, onAnswer, onClose}: any) {
    return (
        <Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{fontSize: 16}}>Does this change require retraining?</DialogTitle>
            <DialogContent>
                <Typography style={{fontSize: 14, marginBottom: 10}}>
                    This record requires retraining, so submitting it needs an answer: does
                    <strong> this </strong> change require people to take the training again?
                </Typography>
                <Typography style={{fontSize: 12, color: Grey6}}>
                    Yes clears everyone's completion when the revision is released, and they are
                    asked to train on it again. No leaves prior completions standing — the right
                    answer for a correction that does not change what anybody has to do.
                    Your answer is shown to the approvers as part of what they sign.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={busy} sx={{textTransform: "none"}}>Cancel</Button>
                <Button onClick={() => onAnswer(false)} disabled={busy}
                        sx={{textTransform: "none"}}>No, completions stand</Button>
                <Button onClick={() => onAnswer(true)} disabled={busy} variant="contained"
                        sx={{textTransform: "none"}}>Yes, retrain</Button>
            </DialogActions>
        </Dialog>
    );
}
